import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  },
  resources: {
    en: {
      translation: {

        Website: 'Website',
        Filings: 'Prospectus',

        model_ratio_method:
          'Model ratios are calculated as a weighted average of the values of the underlying holdings.',
        model_blended_ratio_method:
          'Model and Blended ratios are calculated as a weighted average of the values of the underlying holdings.',
        approach: 'Do you want a strategic or global dividend approach?',
        risk_profiles: 'Select a risk profile',
        edit_name: 'Edit Portfolio Name',
        next1: 'Next',
        risk_profiles: 'RISK',
        num_risk_profiles: 'How many custom models would you like to create, each one being a different allocation between asset classes?',
        next: 'Next',
        welcome: 'Welcome to WisdomTree’s On-Demand Custom Model Portfolio App',
        goal: 'Our goal is to help you create and manage personalized portfolios for your specific client goals.  To get started, please answer the following questions:',
        approach_text1: 'To get started, please answer the following questions: ',
        approach_text2:
          'Do you want your portfolio to be positioned more towards income or growth?',
        sleeve_text1a: 'You chose',
        sleeve_text1b: 'which is our',
        sleeve_text1c: 'you can view the holdings below.',
        sleeve_text2: 'Would you like to make any fund modifications?',
        risk_text1:
          'We will incorporate any modifications that you made into the final portfolios.  Now let’s determine the number of portfolios that you’d like to create. ',
        review_models_text:
          "Please review the portfolios below. Once finalized, you will be able to track these portfolios in My Portfolio Hub.",
        general_text: 'The inception date of these portfolios is ',
        general_text2:
          ' They will be managed by WisdomTree’s Model Portfolio Investment Team on a quarterly basis, and you will be notified of any rebalance changes as they occur.',
        failure_1:
          'Unfortunately there was an issue creating the below custom portfolios.',
        failure_2: ' Please try again.',

        portfolioHubText_1: 'You can view these portfolios at any time on',
        portfolioHubText_2:
          'This is where you’ll be able to find white-labeled fact sheets and quarterly commentary. '
      },
      allocations: 'Allocations',
      holdings: 'Holdings',
      morning_star: 'Morning Star Categories',
      name: 'Name',
      ticker: 'Ticker',
      equity: 'Equity',
      'fixed income': 'Fixed Income',
    }
  }
})

export default i18n
